var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"image-modal",attrs:{"name":"image-modal","height":"auto","adaptive":true,"scrollable":true},on:{"before-open":_vm.beforeOpen}},[_c('img',{attrs:{"src":_vm.image},on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }